import React from 'react';
import Feed from '../../Feed';

const MyChannelsTab = ({ ownChannels, location }) => (
  <div className="tab-content">
    <Feed
      list={ownChannels}
      location ={location}
      renderType={"channels"}
      eventType={"all"}
      pageType={"myProfile"}
    />
  </div>
);

export default MyChannelsTab;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/MyChannelsTab/index.js